import { Typography, Grid, useTheme, useMediaQuery } from "@mui/material";
import type { ReactNode } from 'react';
import suggestIcon from '../../../../images/suggest.svg';
import { MuiClasses } from '../../../../types';
import { withStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { commonCardStyles } from '../../../../styles/commonCards';
type SuggestProps = {
    classes: MuiClasses;
    content?: ReactNode;
    containerMaxWidth?: string;
    contentMaxWidth?: string;
    isModal?: boolean;
    bigPaddingOnLargeScreens?: boolean;
    mediumPaddingOnLargeScreens?: boolean;
    padding?: string;
    suggestContainerPadding?: string;
    desktopMaxWidth?: string;
    // When true, on desktop align box to left instead of centered
    alignLeftOnDesktop?: boolean;
    footerContent?: ReactNode;
    disableAutoMargin?: boolean;
};
const styles = ({ breakpoints }: Theme) => ({
    largeForm: {
        padding: '35px 0 15px 0',
        display: 'flex',
        justifyContent: 'center',
        justifySelf: 'center',
        margin: 0,
        // Center below 1200px to align with form width
        [breakpoints.down('lg')]: {
            margin: 'auto'
        },
        [breakpoints.down('sm')]: {
            padding: '10px 0'
        },
        [breakpoints.up('lg')]: {
            display: 'flex'
        }
    },
    suggestContainer: {
        ...commonCardStyles.cardBackground,
        padding: '25px 40px',
        display: 'flex',
        fontSize: '12px',
        ...commonCardStyles.cardRadius25,
        // '> div': {
        //   display: 'flex'
        // },
        [breakpoints.up('xs')]: {
            padding: '25px'
        },
        '& img': {
            marginRight: '10px',
            marginBottom: '10px'
        }
    },
    suggestIcon: {
        float: 'left' as const,
        padding: '5px'
    },
    suggestText: {
        textAlign: 'left' as const,
        [breakpoints.up('md')]: {
            overflow: 'hidden'
        }
    },
    footerContent: {
        display: 'flex',
        flexDirection: 'column' as const,
        width: '100%'
    }
});
const Suggest = ({ classes, content, containerMaxWidth, contentMaxWidth, isModal, bigPaddingOnLargeScreens, mediumPaddingOnLargeScreens, padding, suggestContainerPadding, // Destructure padding prop
desktopMaxWidth, alignLeftOnDesktop, footerContent, disableAutoMargin }: SuggestProps) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMidDesktop = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    // Full-width infoBox between 490px and 600px
    const isXsWide = useMediaQuery('(min-width:490px) and (max-width:599.95px)');
    const isFullWidth = (containerMaxWidth === '100%' && contentMaxWidth === '100%');
    return (<div className={classes.largeForm} style={{
            // Desktop width can be overridden via desktopMaxWidth; default to 650px
            maxWidth: isFullWidth
                ? '100%'
                : (isTablet || isXsWide || isMidDesktop)
                    ? '550px'
                    : (desktopMaxWidth || '650px'),
            padding: padding || '35px 0 15px 0',
            justifyContent: (isFullWidth || (alignLeftOnDesktop && isDesktop)) ? 'flex-start' : undefined,
            margin: disableAutoMargin ? 0 : undefined,
            marginLeft: (isFullWidth || (alignLeftOnDesktop && isDesktop)) ? 0 : undefined,
            marginRight: alignLeftOnDesktop && isDesktop ? 'auto' : undefined
        }}>
      <Grid container className={classes.suggestContainer} style={{
            flexWrap: 'nowrap',
            // md and desktop content capped; allow override. For full-width case force 100%.
            maxWidth: isFullWidth
                ? '100%'
                : (isTablet || isXsWide || isMidDesktop)
                    ? '100%'
                    : (desktopMaxWidth || '650px'),
            width: isFullWidth ? '100%' : undefined,
            ...(bigPaddingOnLargeScreens && isLargeScreen && {
                padding: '50px 40px'
            }),
            ...(mediumPaddingOnLargeScreens && isLargeScreen && {
                padding: '30px 25px'
            }),
            ...(suggestContainerPadding && { padding: suggestContainerPadding })
        }}>
        {!isModal && (<Grid item>
            <img src={suggestIcon}/>
          </Grid>)}
        <Grid item>
          {isModal && <img src={suggestIcon} className={classes.suggestIcon}/>}
          <Typography variant='body2' component='div' className={classes.suggestText} style={{ whiteSpace: 'pre-line' }}>
            {content}
          </Typography>
          {footerContent && (<div className={classes.footerContent}>
              {footerContent}
            </div>)}
        </Grid>
      </Grid>
    </div>);
};
export default withStyles(styles as any)(Suggest);
